<template>
  <a-select ref="select" v-bind="$attrs" :placeholder="lang('请选择')">
    <template v-for="(i, k) in dicData" :key="k">
      <a-select-option :value="`${iconPrefix}${i.font_class}`">
        <div class="flex">
          <smart-icon class="margin-right" :icon="`${iconPrefix}${i.font_class}`" />
          <div>{{ i.name }}</div>
        </div>
      </a-select-option>
    </template>
  </a-select>
</template>

<script lang="tsx" setup name="SmartIconPicker">
import SmartIcon from '../smart-icon/index.vue'
import {inject, reactive, ref} from 'vue'
import iconfontJson from './iconfont.ts'
const lang = inject('lang')
const iconPrefix = ref(iconfontJson.css_prefix_text as string)
const dicData: Record<any, any> = reactive(iconfontJson.glyphs as Record<any, any>)
</script>
